import styled from 'styled-components';
import { colors, fontFamily } from '../../Utils/tokens';

/** "Chat AI / Chat / Input / Input" (strokes do Figma são internos: padding = design - 1px). */
export const InputBox = styled.div<{ $compact: boolean }>`
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  gap: 12px;
  width: ${({ $compact }) => ($compact ? '384px' : '100%')};
  max-width: 100%;
  padding: 11px 7px 7px 11px;
  border: 1px solid ${colors.surfaceOutline};
  border-radius: 6px;
  background-color: ${colors.surface};
  cursor: text;
  transition: border-color 0.15s ease;

  &:focus-within {
    border-color: ${colors.primary};
  }
`;

export const TextArea = styled.textarea`
  display: block;
  width: 100%;
  /* 3 linhas vazias (18px cada + 4px de padding) para a área de digitação não parecer "espremida" */
  min-height: 58px;
  max-height: 160px;
  margin: 0;
  padding: 2px 0 2px 4px;
  overflow-y: auto;
  border: none;
  outline: none;
  background: transparent;
  font-family: ${fontFamily};
  font-size: 12px;
  font-weight: 400;
  line-height: 18px;
  color: ${colors.onSurface};
  resize: none;

  &::placeholder {
    color: ${colors.onSurfacePlaceholder};
  }

  &:disabled {
    background: transparent;
    cursor: default;
  }
`;

export const ActionsRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  width: 100%;
`;

export const LeftActions = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  min-width: 0;
`;

/** "Chat AI / Chat / Input / Add Button" */
export const AddButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  padding: 5px;
  border: 1px solid ${colors.surfaceOutline};
  border-radius: 999px;
  background-color: ${colors.surface};
  cursor: pointer;

  img {
    width: 16px;
    height: 16px;
  }

  &:hover:not(:disabled) {
    background-color: ${colors.surfaceContainer};
  }

  &:disabled {
    cursor: not-allowed;
  }
`;

export const SendButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  gap: 6px;
  padding: 7px 11px;
  border: 1px solid ${colors.primary};
  border-radius: 6px;
  background-color: ${colors.primary};
  font-family: ${fontFamily};
  font-size: 12px;
  font-weight: 600;
  line-height: 16px;
  color: ${colors.onPrimary};
  text-align: center;
  cursor: pointer;
  transition: filter 0.15s ease;

  &:hover:not(:disabled) {
    filter: brightness(1.1);
  }

  &:disabled {
    border-color: ${colors.onSurfacePlaceholder};
    background-color: ${colors.surfaceOutline};
    color: ${colors.onSurfacePlaceholder};
    cursor: default;
  }
`;
